import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import config from 'constants/config'
import { useIsBannerHidden } from 'hooks/useIsBannerHidden'
import ContactOptionsBanner from '../Header/HeaderBanners/ContactOptionsBanner'
import HeaderTopBanners from '../Header/HeaderTopBanners'
import { useLocation } from 'react-router-dom'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

function BannerRoutes() {
  const location = useLocation()
  const isCorporateEvent = matchLocaleAwarePath(location.pathname, {
    path: '/:regionCode/corporate-events/:eventId',
    exact: true,
  })
  const isHidden = useIsBannerHidden('headerTopBanners')

  if (isCorporateEvent) return null

  return <>
    {config.SHOW_CONTACT_BANNER && !config.NAVKIT_NAVBAR_ENABLED && <CSSBreakpoint max="mobile">
      <ContactOptionsBanner />
    </CSSBreakpoint>}
    {!isHidden && <HeaderTopBanners />}
  </>
}

export default BannerRoutes
